<template>
  <PageWrapper
    v-if="canView"
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_SETTINGS"
    title="Settings"
    :breadcrumbs="breadcrumbs"
    page-name="Settings"
    align="left"
    width="full"
  />
  <iText v-else>
    You don't have access to view this page.
  </iText>
</template>

<script>
import { mapState } from "pinia";
import PageWrapper from "@/components/PageWrapper.vue";
import { PAGE_PUBLICATION_SETTINGS, SECTION_PUBLICATIONS } from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useCollaboratorStore } from "@/stores/collaborator-store";

export default {
  name: "PublicationSettings",
  components: {
    PageWrapper,
  },
  data() {
    return {
      SECTION_PUBLICATIONS,
      PAGE_PUBLICATION_SETTINGS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
      "publicationId",
    ]),
    ...mapState(useCollaboratorStore, [
      "canView",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
      ];
    },
  },
  mounted() {
    if (!this.canView) {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/publication/${this.publicationId}`;

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  },
};
</script>
